export const AVATAR_EDITOR_BREAKPOINT = 600;
export const AVATAR_EDITOR_BORDER = 50;
export const AVATAR_EDITOR_COLOR = [29, 148, 29, 0.6];
export const AVATAR_EDITOR_ROTATE = 0;
